package ld.scenes;
import pixi.core.renderers.SystemRenderer;
import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.extras.BitmapText;
import pixi.extras.AnimatedSprite;

import stocking.ColoredBitmapText;
import stocking.SceneManager;

import tweenx909.TweenX;
import tweenxcore.color.RgbColor;
import tweenxcore.Tools.Easing;

import ld.NotificationWindow;

import stocking.AudioManager;



import stocking.Scene;

class MenuScene extends Scene
{
	var bgPosition = { x: 0., y: 0.};
	var containerScene : Container = new Container();
	var containerBG : Container = new Container();

	public function new( renderer : SystemRenderer, stage : Container )
	{
		super( renderer, stage );
		strMusicTrack = "assets/music/Rynos Theme.mp3";
	}

    public override function preload()
    {
		loaderImages = [
			{ filename: "assets/Menu_Title.png"},
			{ filename: "assets/Large_Button.png"},
			
		];

		loaderFonts = [
			"assets/khdot16.fnt",
			"assets/khdot12.fnt",
		];

		loaderSfx = [
			"assets/sfx/MENU B_Select.wav",
			"assets/sfx/MENU A_Select.wav",
			"assets/sfx/MENU_Pick.wav",
			"assets/sfx/Menu Select 1.wav",
			
		];
		super.preload();
    }

	public override function enter()
	{

		super.enter();

		trace("Enter");

		var bg = new Sprite( Texture.fromImage( "assets/Menu_Title.png" ) );
		containerBG.addChild(bg);

		container.addChild(containerBG);
		container.addChild(containerScene);
		
		
	
		// New game btn
		var btn = Util.MakeBigButton("New Game");
		btn.click = btn.tap = function( event : pixi.interaction.InteractionEvent ) { 
			AudioManager.instance.play("assets/sfx/MENU A_Select.wav");
			TweenX.to( container, {alpha: 0}).time(0.5).onFinish(function(){
				SceneManager.instance.transitionToScene(new MapScene(renderer, stage));
			});
		};

		btn.mouseover = function( event : pixi.interaction.InteractionEvent ) { 
			// @todo juice
			AudioManager.instance.play("assets/sfx/MENU_Pick.wav");
		};

		btn.x = 400;
		btn.y = 400;
		

		containerScene.addChild( btn );



		container.alpha = 0;

		TweenX.to( container, { alpha: 1 } ).time(1);
		
		
	}

	public override function tick( delta : Float )
	{
		
	}


}
